import setBadgePosition from '../features/badge-position';
import {Quickview} from '../features/quickview';
import {makeGridSwatches} from '../features/swatch';
import {register} from '../vendor/theme-scripts/theme-sections';
import debounce from '../util/debounce';

const sections = {};

const selectors = {
  recentlyViewed: '#RecentlyViewed',
  dataLimit: 'data-limit',
  productBlock: '[data-product-block]',
  productImage: '[data-product-image]',
  productBadge: '[data-badge]',
};

class RecentlyViewedProducts {
  constructor(section) {
    this.section = section;
    this.container = section.container;
    this.limit = parseInt(this.container.getAttribute(selectors.dataLimit));
    this.recentlyViewed = this.container.querySelector(selectors.recentlyViewed);
    this.setBadgePositionOnResizeEvent = null;

    if (this.recentlyViewed) {
      this.init();
    }
  }

  init() {
    Shopify.Products.showRecentlyViewed({
      howManyToShow: this.limit,
      onComplete: () => {
        const recentlyViewedProducts = this.container.querySelectorAll(selectors.productBlock);

        if (recentlyViewedProducts.length > 0) {
          makeGridSwatches(this.container);
          new Quickview(this.container);

          const images = this.container.querySelectorAll(selectors.productImage);

          if (theme.settings.imageBackgroundSize === 'contain' && images) {
            setBadgePosition(images);
            this.setBadgePositionOnResizeEvent = (images) => setBadgePosition(images);

            document.addEventListener('theme:resize', this.setBadgePositionOnResizeEvent);
          }

          // Force lazyloading
          images.forEach((image) => {
            lazySizes.loader.unveil(image);
          });

          // Add new lines in badges
          if (theme.settings.productBadgeStyle === 'circle') {
            this.container.querySelectorAll(selectors.productBadge).forEach((badge) => {
              let badgeText = badge.innerText;
              badgeText = badgeText.replace(' ', '<br>');
              badge.innerHTML = badgeText;
            });
          }
        }
      },
    });
  }
  onUnload() {
    if (this.setBadgePositionOnResizeEvent) {
      document.removeEventListener('theme:resize', this.setBadgePositionOnResizeEvent);
    }
  }
}

const recentlyViewedProductsSection = {
  onLoad() {
    sections[this.id] = new RecentlyViewedProducts(this);
  },
  onUnload(e) {
    sections[this.id].onUnload(e);
  },
};

register('recently-viewed-products', recentlyViewedProductsSection);
